import XAPPService from 'app/Core/services/XAPPService';
export const GET_MEUSCONVITES = '{MEUSCONVITES APP] GET MEUSCONVITES';
export const MEUSCONVITES_WARNING = '{MEUSCONVITES APP] MEUSCONVITES WARNING';
export const MEUSCONVITES_INFO = '{MEUSCONVITES APP] MEUSCONVITES INFO';
export const MEUSCONVITES_ERROR = '{MEUSCONVITES APP] MEUSCONVITES ERROR';

const ListState = [
    'tipo',
    'idchave',
    'status',
    'destinatario',
    'destinatariodados',
    'remetente',
    'remetentedados',
    'codigo',
    'formulario',
    'descricao',
    'validade',
    'validadedescricao',
    'statusregistro',
    'statusregistrodescricao'
];

const AddState = [
    'idchave',
    'status',
    'tipo',
    'remetente',
];

export function list(_AID) {

    return (dispatch) => {

        var AConditionsAND = [
            { Campo: "chave.tipo", Operador: "=", Valor: 1 },
            { Campo: "chave.statusregistro", Operador: "=", Valor: 1 },
            { Campo: "chave.destinatario", Operador: "=", Valor: _AID }
        ];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappSelActionFactory(0, "MeusConvites", AActions, "spvwchave", ListState, "SELECIONAR", AConditionsAND, AConditionsOR)

        XAPPService.XappRegisterAction(AActions, 'SEL')
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_MEUSCONVITES,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: MEUSCONVITES_ERROR,
                    payload: error
                });
            });
    };
}

export function save(_AValue, _AID) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappDoActionFactory(0, AActions, "chave", "ALTERARSTATUSCHAVE", _AValue, "", AConditionsAND, AConditionsOR, 1, AddState);

        XAPPService.XappRegisterAction(AActions, "CUSTOM")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: MEUSCONVITES_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => window.location.reload())
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: MEUSCONVITES_INFO,
                            payload: response.info,
                            id: response.ultimoidinserido
                        })
                    ]).then(() => window.location.reload())
                }
            }).catch(error => {
                return dispatch({
                    type: MEUSCONVITES_ERROR,
                    payload: error
                });
            });
    };
}
